import React,{useState} from "react";
import {useForm} from "react-hook-form";
import { toSeconds } from "../utils/utils";
import axiosInstance from "../services/axios";
import { useNavigate } from "react-router-dom";


function OrganisedDebate(){
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState([{ topics: ""}]);
    const [count,setCount] = useState(1);
    const intermediate_details = [];

    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i][e.target.name] = e.target.value;
        setFormValues(newFormValues);
    }
    let addFormFields = () => {
        let field_count = count+1;
        setCount(field_count);
        setFormValues([...formValues, { topics: ""}])
    }
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
    }=useForm();
    let removeFormFields = (i) => {
        let field_count = count-1;
        setCount(field_count);
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }

    const onSubmit = async(values)=>{
        const participants_code = Math.random().toString(36).slice(4);
        const audience_code =  Math.random().toString(36).slice(4);
        values.participants_code = participants_code;
        values.audience_code = audience_code;
        const intermediate_details = [];
        intermediate_details.push({"topics":[values.topics],"counter_time":values.counter_time,"counter_statement":values.counter_statement});
        values.intermediate_details = intermediate_details;
        delete values.topics;
        delete values.counter_statement;
        delete values.counter_time;
        try{
            await axiosInstance.post(`/create/`, values);        
            navigate("/debates", { replace: true }); // <-- redirect
        }
        catch(err){
            throw(err)
        }



    }

    return (
        <form className="Intermediate" onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" name="type" value="intermediate" {...register("type")} />

        <div className="form-step-row">
                <div className="form-row-left">
                    <label htmlFor="input2">Title of debate</label>
                </div>

                <div className="form-row-right">
                    <div className="form-group">
                        <input type="text" className="form-control" id="title" name="title" placeholder="Enter debate title" {...register("title", {
                                    required: "This is required field",
                        })}/>
                    </div>
                    {errors.title && <span className="error-message">Title is required</span>}

                </div>
            </div>

            <div className="form-step-row">
                <div className="form-row-left">
                    <label htmlFor="input3">Time of debate</label>
                </div>

                <div className="form-row-right">
                    <div className="form-group">
                        <div className="form-control time-input-div d-flex align-items-center">
                            <input type="text" min="0" max="23" placeholder="00" maxLength="2" name="total_hour" {...register("total_hour", {
                                    required: "This is required field",
                                })} />
                            <span>hr</span>
                            <input type="text" min="0" max="59" placeholder="00" maxLength="2" name="total_minutes" {...register("total_minutes", {
                                    required: "This is required field",
                                })}/>
                            <span>min</span>
                        </div>
                        <img src={process.env.PUBLIC_URL+"img/timer-watch-icon-black.png"} className="icon" alt="" title="" width="16" />
                    </div>
                    {errors.total_hour && <span className="error-message">hour is required </span>}
                {errors.total_minutes && <span className="error-message">minutes is required</span>}

                </div>
              

            </div>

            <div className="form-step-row form-step-top-align">

                    <div className="form-row-left">
                        <label htmlFor="topics">Topic of debate</label>
                    </div>

                    <div className="form-row-right">

                            {formValues.map((element,index) => (
                            <div key={index} className="form-group mb-3">
                                <input type="text" className="form-control" id="topics" name={`topics[${index}]`} placeholder="Enter debate topic" onChange={e => handleChange(index, e)} {...register(`topics.${index}`)}/>
                                { index ?
                                    <span className="delete" onClick={() => removeFormFields(index)}>Delete</span>:""

                                }
                            </div>

                            ))}
                            

                            <div className="form-group" >
                                    <a style={{cursor: "pointer"}} className="add-topic" onClick={() => addFormFields()} >+ Add more</a>
                            </div>

                    </div>
                    

            </div>
            
            {/* No of counter statement */}
            
            <div className="form-step-row form-step-less-space">
                <div className="form-row-left" >
                    <label id="time_title" >Time of counter statement</label>
                </div>

                <div className="form-row-right" id="time_counter_statement">
                    <div className="radio-input mr-2">
                        <input type="radio" id="time1" name="counter_time" value="30" {...register("counter_time")} />
                        <label htmlFor="time1">30 secs</label>
                    </div>

                    <div className="radio-input mr-2">
                        <input type="radio" id="time2" name="counter_time" value="40" {...register("counter_time")}/>
                        <label htmlFor="time2">40 secs</label>
                    </div>

                    <div className="radio-input mr-2">
                        <input type="radio" id="time3" name="counter_time" value="50s" {...register("counter_time")}/>
                        <label htmlFor="time3">50 secs</label>
                    </div>

                    <div className="radio-input">
                        <input type="radio" id="time4" name="counter_time"  value="60" {...register("counter_time")}/>
                        <label htmlFor="time4">60 secs</label>
                    </div>
                </div>
            </div>
            
            {/*  */}

            <div id="organised_debate_extra_section">
                <div className="form-step-row form-step-less-space" > 
                    <div className="form-row-left" >
                        <label id="chance_title" >Chances of counter statement</label>
                    </div>

                    <div className="form-row-right" id="chance_counter_statement" >
                        <div className="radio-input mr-2">
                            <input type="radio" id="chance0" name="counter_statement" value="0" {...register("counter_statement")}/>
                            <label htmlFor="chance0">0</label>
                        </div>

                        <div className="radio-input mr-2">
                            <input type="radio" id="chance2" name="counter_statement" value="2"  {...register("counter_statement")}/>
                            <label htmlFor="chance2">2</label>
                        </div>

                        <div className="radio-input mr-2">
                            <input type="radio" id="chance5" name="counter_statement" value="5"  {...register("counter_statement")}/>
                            <label htmlFor="chance5">5</label>
                        </div>

                        <div className="radio-input">
                            <input type="radio" id="chance10" name="counter_statement" value="10"  {...register("counter_statement")}/>
                            <label htmlFor="chance10">10</label>
                        </div>
                    </div>
                </div>
            </div> 


            <div className="form-step-row form-step-less-space">
                <div className="form-row-left">
                    <label>No. of members on each side</label>
                </div>

                <div className="form-row-right">
                    <div className="radio-input mr-2">
                        <input type="radio" id="organisedMember1" name="members_each_side" value="1" {...register("members_each_side")}/>
                        <label htmlFor="organisedMember1">1</label>
                    </div>

                    <div className="radio-input mr-2">
                        <input type="radio" id="organisedMember2" name="members_each_side" value="2" {...register("members_each_side")}/>
                        <label htmlFor="organisedMember2">2</label>
                    </div>

                    <div className="radio-input mr-2">
                        <input type="radio" id="organisedMember3" name="members_each_side" value="3" {...register("members_each_side")}/>
                        <label htmlFor="organisedMember3">3</label>
                    </div>

                    <div className="radio-input mr-2">
                        <input type="radio" id="organisedMember4" name="members_each_side" value="4" {...register("members_each_side")}/>
                        <label htmlFor="organisedMember4">4</label>
                    </div>

                    <div className="radio-input">
                        <input type="radio" id="organisedMember5" name="members_each_side"  value="5" {...register("members_each_side")}/>
                        <label htmlFor="organisedMember5">5</label>
                    </div>
                </div>
            </div>
            
        <div className="form-step-row last">
            <div className="form-row-left">
            </div>

            <div className="form-row-right">
                {/* <button type="submit" className="btn btn-primary"></button> */}
                <input type="submit" className="btn btn-primary"  value="Finish" />
            </div>
        </div>

    </form> 
    );
}

export default OrganisedDebate;